import React from 'react';
import './Skills.css';

const skillCategories = [
  {
    title: 'Frontend',
    skills: [
      { name: 'HTML5', level: 'Expert' },
      { name: 'CSS3', level: 'Expert' },
      { name: 'JavaScript', level: 'Expert' },
      { name: 'Angular', level: 'Expert' },
      { name: 'Vue.js', level: 'Expert' },
      { name: 'React', level: 'Proficient' },
      { name: 'jQuery', level: 'Proficient' },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Node.js', level: 'Proficient' },
      { name: 'PHP', level: 'Proficient' },
      { name: 'Laravel', level: 'Proficient' },
      { name: 'Python', level: 'Proficient' },
    ],
  },
  {
    title: 'Mobile',
    skills: [
      { name: 'Ionic', level: 'Expert' },
      { name: 'Flutter', level: 'Proficient' },
    ],
  },
  {
    title: 'Data & CMS',
    skills: [
      { name: 'WordPress', level: 'Expert' },
      { name: 'MongoDB', level: 'Proficient' },
      { name: 'MySQL', level: 'Proficient' },
      { name: 'Firebase / Firestore', level: 'Proficient' },
    ],
  },
];

const Skills = () => (
  <section id="skills" className="skills wrap">
    <div className="spec">
      <div className="spec-bar mono">
        <span>Spec sheet — tools on the bench</span>
        <span className="spec-legend">
          <span><span className="level expert">EXP</span> production-proven, daily driver</span>
          <span><span className="level">PRO</span> used in shipped projects</span>
        </span>
      </div>
      <div className="spec-grid">
        {skillCategories.map((category) => (
          <div key={category.title} className="spec-col">
            <h3 className="spec-title eyebrow">{category.title}</h3>
            <ul className="spec-list">
              {category.skills.map((skill) => (
                <li key={skill.name} className="spec-item">
                  <span className="spec-name">{skill.name}</span>
                  <span className="spec-dots" aria-hidden="true" />
                  <span className={`level mono ${skill.level === 'Expert' ? 'expert' : ''}`}>
                    <span className="visually-hidden">{skill.level}</span>
                    <span aria-hidden="true">{skill.level === 'Expert' ? 'EXP' : 'PRO'}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
